import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthFormModal from './AuthFormModal';
import SubFormModal from './SubFormModal';
import UpdateAvatarModal from './UpdateAvatarModal';
import DarkModeMenuItem from './DarkModeMenuItem';
import { getCircularAvatar } from '../utils/cloudinaryTransform';
import storageService from '../utils/localStorage';

import {
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  ListItemIcon,
  Divider,
  SvgIcon,
} from '@material-ui/core';

import { ReactComponent as Staricon } from '../svg/staricon.svg';
// import FilterVintageIcon from '@material-ui/icons/FilterVintage';

import { ReactComponent as MyProfileIcon } from '../svg/myProfileIcon.svg';


import { ReactComponent as LogOutIcon } from '../svg/logOutIcon.svg';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';


import { useUserMenuStyles } from '../styles/muiStyles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const MobileUserMenu = ({ user, handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useUserMenuStyles();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    handleLogout();
  };

  const loggedUser = storageService.loadUser() || user;

  return (
    <div>
      {loggedUser ? (
        <IconButton onClick={handleMenu} className={classes.userBtnMob}>
          {loggedUser?.avatar?.exists ? (
            <Avatar
              alt={loggedUser.username}
              src={getCircularAvatar(loggedUser.avatar.imageLink)}
              className={classes.avatar}
            />
          ) : (
            <Avatar className={classes.avatar}>{loggedUser.username[0]}</Avatar>
          )}
          <MoreVertIcon color="primary" />
        </IconButton>
      ) : (
        <IconButton onClick={handleMenu} color="primary">
          <MoreVertIcon color="primary" />
        </IconButton>
      )}
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {loggedUser ? (
          <div>
            <MenuItem
              component={RouterLink}
              to={`/u/${loggedUser.username}`}
              onClick={handleClose}
            >
              <ListItemIcon>
               
              <SvgIcon style={{ marginRight: 7 }} > 
              <MyProfileIcon style={{ color: "primary" }} />
              </SvgIcon > 
              My Profile
              </ListItemIcon>
            </MenuItem>
            <SubFormModal type="menu" handleCloseMenu={handleClose} />
            <UpdateAvatarModal
              handleCloseMenu={handleClose}
              user={loggedUser}
            />
            <DarkModeMenuItem closeMenu={handleClose} />
            <Divider variant="middle" />

            <MenuItem onClick={handleLogoutClick}>
            <ListItemIcon >
              <SvgIcon style={{ marginRight: 7 }} > 
              <LogOutIcon style={{ color: "primary" }} />
              </SvgIcon > 
              Logout
              {/* <box-icon name='log-out' style={{ marginRight: 7 }} ></box-icon> Logout */}
                {/* <PowerSettingsNewIcon style={{ marginRight: 7 }} /> Logout */}
              </ListItemIcon>
            </MenuItem>
            
          </div>
        ) : (
          <div>
            <AuthFormModal closeMobileMenu={handleClose} />
            <Divider variant="middle" />
            <DarkModeMenuItem closeMenu={handleClose} />
          </div>
        )}
      </Menu>
    </div>
  );
};

export default MobileUserMenu;
